import { END_POINTS } from "../helpers";
import emptySplitApi from "../utils/rtk";

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};
export const discountApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getDiscountList: builder.query<
      CommonResponse,
      { page?: number; limit?: number; search?: string }
    >({
      query: (params) => {
        const newParams: any = { ...params };
        if (!newParams.search) delete newParams.search;
        return {
          url: END_POINTS.discountList,
          method: "GET",
          params: newParams,
        }
      },
    }),
    adddiscount: builder.mutation<CommonResponse, any>({
      query: (body) => ({
        url: END_POINTS.discounts,
        method: "POST",
        body,
      }),
    }),
    toggleDiscount: builder.mutation<CommonResponse, { id: string; body: any }>({
      query: ({ id, body }) => ({
        url: `${END_POINTS.toggleDiscount}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getDiscountDetails: builder.query<
      CommonResponse,
      { id: string | undefined }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.discountById}/${id}`,
        method: "GET",
      }),
    }),
    updatediscount: builder.mutation<CommonResponse, { id: string; body: any }>(
      {
        query: ({ id, body }) => ({
          url: `${END_POINTS.discountById}/${id}`,
          method: "PUT",
          body,
        }),
      },
    ),
    deleteDiscount: builder.mutation<CommonResponse, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.discountById}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});
export const {
  useLazyGetDiscountListQuery,
  useAdddiscountMutation,
  useUpdatediscountMutation,
  useLazyGetDiscountDetailsQuery,
  useDeleteDiscountMutation,
  useToggleDiscountMutation
} = discountApi;
